import { gql } from "@apollo/client";

export const INIT_MULTIPART_UPLOAD = gql`
  mutation InitMultipartUpload($input: MultipartUploadInitInput!) {
    initMultipartUpload(input: $input) {
      type
      uploadId
      entityId
      fileId
      objectKey
      partSizeBytes
      partCount
      parts {
        partNumber
        url
      }
      expiresAt
      uploadMethod
      contentType
    }
  }
`;
